import React from 'react'
import { Link } from 'react-router-dom';
import Loading from '../../../Components/Loading';

function Category({ categoreis = [], load , scrolled }) {

    const Item = ({ item }) => {

        return (
            <Link to={'/Category'} state={{ category: item }} className='category-item   mx-auto text-center my-2'>
                <div className='category' style={{ overflow: "hidden" }}>
                    {item.meta_data && item.meta_data.icon && <img src={item.meta_data.icon} alt={item.title} />}
                </div>
                <small className="category-name">{item.title}</small>
            </Link>
        );
    }


    return (
        <div className="categories col-lg-4">
            <div className={`d-flex ${scrolled && 'scrolled'}`}>
                {load ?
                    <Loading count={10} height={40} width={40} radius={40} className="category-item  mx-auto text-center my-2" />
                    :
                    categoreis && categoreis.map((item, i) => {
                        if (i == 0) {
                            return null
                        }
                        return (<Item item={item} key={i} />)
                    })}
            </div>
        </div>
    )
}

export default Category